import { graphql } from '@graphql/__generated'

export const GET_MEMBERSHIP_FOR_ORGANISATION = graphql(`
  query GetMembershipOptionsForOrganisation($data: String!) {
    getMembershipForOrganisation(organisationName: $data) {
      __typename

      ... on GetMembershipOutput {
        details {
          isPublished
          title
          bannerImage
          thumbnailImage
          description
          shortDescription
          confirmationText
          membershipId
          emailTemplates {
            title
            data
            trigger
            content
            sentDateTime
          }
        }
        product {
          productId
          prices {
            priceAmount
            priceId
            interval
            currency
            title
            pillText
          }
          name
        }
      }

      ... on APIError {
        error
        code
      }
    }
  }
`)
